import { ContentBackground } from 'components/ContentBackground';
import React, { ReactNode } from 'react';

interface ChildPageProps {
  children: ReactNode;
}

export const ChildPage = ({ children }: ChildPageProps) => <ContentBackground>{children}</ContentBackground>;
